import classNames from 'classnames';
import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import { ConnectedBidAsk } from 'components/secondaryMarket/shared/SidePanel/BidAsk';
import { ConnectedDlpRealtimeFooter } from 'components/secondaryMarket/shared/SidePanel/DlpRealtimeFooter.connect';
import { ActionButton, ButtonPanel, MessagesPanel } from 'components/secondaryMarket/shared/status';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { FC } from 'react';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';

import type { ReadySidePanelProps } from './ReadySidePanel.connect';

const readyToPlaceOrder: SecondaryMarketFormError[] = [
  {
    fields: [],
    severity: 'Warning',
    translationKey: 'readyToPlaceOrder',
    values: {},
  },
];

export const ReadySidePanel: FC<ReadySidePanelProps> = ({
  onPlaceOrder,
  isOrderPlacementEnabled,
  className,
  tabId,
}) => {
  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <PanelHeader color="lvl1" discreet className="border border-bottom-0 p-0">
        <ConnectedBidAsk tabId={tabId} />
      </PanelHeader>
      <PanelFooter
        color="lvl1"
        className="border"
        discreet
        statusKey="secondaryMarket.sidePanel.label.ready"
        icon="offline_bolt"
      >
        <ConnectedDlpRealtimeFooter className="flex-grow-1" tabId={tabId} />
      </PanelFooter>
      <MessagesPanel
        errors={[...readyToPlaceOrder]}
        className="flex-grow-1 pt-2"
        e2e="side-panel-header"
        colorToSeverity={lessAgressiveColorMapper}
      ></MessagesPanel>

      <ButtonPanel>
        <ActionButton
          color="primary"
          label="secondaryMarket.sidePanel.label.placeOrder"
          disabled={!isOrderPlacementEnabled}
          onClick={onPlaceOrder}
        />
      </ButtonPanel>
    </div>
  );
};
ReadySidePanel.displayName = 'ReadySidePanel';
